import * as React from 'react'
import { Box, CircularProgress } from '@material-ui/core'
import {
  APIProvider,
  // eslint-disable-next-line
} from '@vis.gl/react-google-maps/dist/index.umd.js'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchParkingLotData,
  fetchRoutes,
  fetchStops,
  fetchTrips,
  resetMap,
  setLatLang,
} from './sections/Map/redux/myMapsSlice'

import MapSearchBar from './components/Search/MapSearchBar'
import MapPanelMobile from './mobile/MapPanelMobile/MapPanelMobile'
import BuildingPanel from './sections/Buildings/BuildingPanel'
import {
  resetParking,
  fetchBuildings,
  resetBuilding,
} from './sections/Buildings/redux/myBuildingsSlice'

import { getOverallState } from './sections/Map/helpers/helpers'
import { getLatLang } from './sections/Buildings/utils/helpers'
import MapPanelTwo from './sections/Map/MapPanelTwo'
import { fetchMyProfile } from '../dashboard/widgets/MyProfile/myProfileSlice'
import CheckIsMobile from '../../../utils/isMobileHook'

export default function MyMapTwo() {
  const dispatch = useDispatch()
  const { selectedCampus, map } = useSelector((s) => s.maps)
  const { stopsLoading, routesLoading } = useSelector((state) => state.maps)
  const [mapState, setMapState] = React.useState('pending')
  React.useEffect(() => {
    if (mapState !== 'fulfilled') {
      const loadedState = 'fulfilled'
      // Sometimes requests get hung up here. Unclear why
      const state = getOverallState([loadedState, stopsLoading, routesLoading])
      setMapState(state)
    }
  }, [stopsLoading, routesLoading])

  // Makes an initial call to fetch static data to be used throughout app
  // Maybe in the future, we can have components that need it call API but this is the easiest way for now
  React.useEffect(() => {
    resetAll()
    dispatch(fetchStops()).then(() => {
      dispatch(fetchTrips()).then(() => {
        dispatch(fetchRoutes())
      })
    })
    dispatch(fetchBuildings())
    dispatch(fetchMyProfile()).then(() => {
      dispatch(fetchParkingLotData())
    })
    // handle direct link to maps route
    const user = localStorage.getItem('user')
    if (!user) {
      dispatch(fetchParkingLotData())
    }
  }, [])

  React.useEffect(() => {
    if (map && mapState === 'fulfilled') {
      dispatch(setLatLang(getLatLang(selectedCampus)))
      const coords = getLatLang(selectedCampus)
      map?.panTo({ lat: coords.lat, lng: coords.lang })
      map?.setZoom(14)
    }
  }, [mapState, map])

  // Resets the map when user navigates to another module.
  React.useEffect(
    () => () => {
      resetAll()
    },
    [],
  )

  const resetAll = () => {
    dispatch(resetMap())
    dispatch(resetParking())
    dispatch(resetBuilding())
  }

  return (
    <Box display="flex" flexDirection="column">
      <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
        {RenderMyMapState(mapState)}
      </APIProvider>
    </Box>
  )
}

function RenderMyMapState(mapState) {
  switch (mapState) {
    case 'fulfilled':
      return <LoadedMap />
    case 'pending':
      return (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress style={{ marginTop: 100, color: '#cc0033' }} />
        </Box>
      )
    default:
      return (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          Error
        </Box>
      )
  }
}

// TODO Web and mobile view is so entangled that it's causing extra renders when it shouldn't.
// These should get separated out
function LoadedMap() {
  const isMobile = CheckIsMobile()
  const [loadMap, updateLoadMap] = React.useState(false)
  React.useEffect(() => {
    // Set up the interval to decrease seconds every 500ms (0.5 seconds)
    const intervalId = setInterval(() => {
      updateLoadMap(true)
    }, 500)

    // Cleanup function: clear the interval when the component unmounts or dependencies change
    return () => clearInterval(intervalId)
  }, [])
  return (
    <div id="main-content">
      {loadMap ? (
        <>
          <MapSearchBar />
          {isMobile ? <MapPanelMobile /> : null}
          <MapPanelTwo />
          <BuildingPanel /> {/* TODO Fix building panel */}
        </>
      ) : null}
    </div>
  )
}
